import React from 'react';
import { Mail, AlertCircle } from 'lucide-react';
import { Button } from '../../atoms/Button';

export interface SuccessMessageProps {
  message: string;
  onClose: () => void;
  isSuccess?: boolean;
}

export const SuccessMessage = ({
  message,
  onClose,
  isSuccess = true,
}: SuccessMessageProps) => {
  return (
    <div className="text-center py-6">
      <div className="mb-4 flex justify-center">
        {isSuccess ? (
          <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center">
            <Mail className="w-8 h-8 text-green-600" />
          </div>
        ) : (
          <div className="w-16 h-16 bg-red-100 rounded-full flex items-center justify-center">
            <AlertCircle className="w-8 h-8 text-red-600" />
          </div>
        )}
      </div>
      <h3 className={`text-xl font-bold mb-2 ${isSuccess ? 'text-gray-800' : 'text-red-800'}`}>
        {isSuccess ? 'İşlem Başarılı' : 'Hata Oluştu'}
      </h3>
      <p className={`mb-6 ${isSuccess ? 'text-gray-600' : 'text-red-600'}`}>{message}</p>
      <Button
        variant={isSuccess ? 'primary' : 'danger'}
        onClick={onClose}
        className="w-full sm:w-auto"
      >
        Tamam
      </Button>
    </div>
  );
};
